<template>
  <div class="container-decreto" :class="{show:isShowDecreto}">
    <button class="toggle-decreto" @click="toggleDecreto">
      <img v-if="isShowDecreto" src="@/assets/iconos/remove_circle_white_24dp.svg" alt="">
      <img v-else class="icon" src="@/assets/iconos/file_open_white_24dp.svg" alt="">
    </button>
    <a class="btn-decreto" v-if="isShowDecreto" href="https://dof.gob.mx/nota_detalle.php?codigo=5679405&fecha=13/02/2023#gsc.tab=0" target="_blank" rel="noopener">
      <span class="btn-icon" aria-hidden="true"> 
        <img class="icon" src="@/assets/iconos/file_open_white_24dp.svg" alt="">
      </span>
      Leer Decreto <span class="a11y-solo-lectura"> (Link externo).</span>
    </a>
  </div>
</template>

<script>
export default {
  name: 'BotonDecreto',
  computed: {
    isShowDecreto () {
      return this.$store.getters.isShowDecreto
    }
  },
  methods: {
    toggleDecreto () {
      this.$store.commit('toggleDecreto')
    }
  }
}
</script>

<style scoped lang="scss">
@keyframes iconBtn {
  0% {
    opacity: .25;
    top: 17px;
  }
  50% {
    opacity: 1;
    top: 5px;
  }
  100% {
    top: 17px;
    opacity: .25;
  }
}

.container-decreto {
  background-color: $accion;
  border-radius: 25px;
  position: fixed;
  left: $space*.5;
  bottom: $space*.5;
  z-index: 99998;
  width: 50px;
  height: 50px;
  overflow: hidden;
  border-radius: 25px;
  transition: all .4s ease-in-out;
  display: flex;
  align-content: center;
  &.show {
    width: 250px;
  }
}
.toggle-decreto {
  background-color: $accion;
  border-radius: 25px 0 0 25px;
  flex: 0 0 50px;
  width: 50px;
  transition: all .3s ease-in-out;
  margin: 0;
}
.btn-decreto {
  white-space: nowrap;
  color: #fff;
  line-height: 50px;
  white-space: nowrap;
  padding-right: $space;
  transition: all .3s ease-in-out;
  border-left: 1px solid rgba(255,255,255,.25);
  flex: 1 1 80vw;
  white-space: nowrap;
  .btn-icon {
    margin: 0 $space*.25;
    .icon {
      position: relative;
      animation: iconBtn 2s ease-in-out infinite;
    }
  }
}
</style>
